import { render, staticRenderFns } from "./Codeblock.vue?vue&type=template&id=139d3ef6&scoped=true"
import script from "./Codeblock.vue?vue&type=script&lang=js"
export * from "./Codeblock.vue?vue&type=script&lang=js"
import style0 from "./Codeblock.vue?vue&type=style&index=0&id=139d3ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d3ef6",
  null
  
)

export default component.exports